// extracted by mini-css-extract-plugin
export default {"wrapper":"arrow_wrapper__WCEWF","icon":"arrow_icon__Lub8E"};